import { IState } from '../../store';

export const selectNewbuildingFromDeveloperIds = (state: IState): number[] => {
  return state.offerData.company?.newbuildingIds || [];
};
